import Tabs from "@/components/Tabs";
import { Path, useNavigate } from "@/router";
import { useLocation, useParams } from "react-router-dom";
import React from "react";

export default function ReportsTabLayout({ children }: { children: React.ReactNode }) {
  const { universityId } = useParams();
  const location = useLocation();
  const navigate = useNavigate();

  const tabItems = [
    {
      label: "Semester",
      to: `/education/universities/${universityId}/reports/semester` as const
    },
    {
      label: "Internship Reporting",
      to: `/education/universities/${universityId}/reports/internship-reporting` as const
    },
    {
      label: "Past Roster Uploads",
      to: `/education/universities/${universityId}/reports/past-roster-uploads` as const
    }
  ];

  return (
    <>
      <Tabs
        showWhenSingle
        tabItems={tabItems.map(({ label, to }) => ({
          label,
          onClick: () => navigate(to as unknown as Path),
          active: location.pathname.startsWith(to)
        }))}
      />
      <div className="flex flex-col" data-testid="tab-content">
        {children}
      </div>
    </>
  );
}
